<dx-pie-chart 
    type="doughnut" 
    [dataSource]="chartItems" 
    [innerRadius]="0.7" 
    [size]="(isLarge ? {height: 250, width:250} : {height: 200, width:200})"
    centerTemplate="centerTemplate" 
    [customizePoint]="customizePoint"
    [legend]="{ visible: false }">
    <dxi-series argumentField="argument" valueField="value">
        <dxo-label [visible]="false"></dxo-label>
    </dxi-series>
    <dxo-tooltip [enabled]="true" [customizeTooltip]="customizeTooltip" format="millions"></dxo-tooltip>
    <svg *dxTemplate="let pieChart of 'centerTemplate'">
        <text text-anchor="middle" style="font-size: 40px; fill: currentColor;" x="100" y="120">
            <tspan x="100" dy="0">{{ item?.value | number:'1.0-2' }}%</tspan>
            <tspan class="text-body-secondary" x="100" dy="20" style="font-size: 14px; fill: currentColor;">{{ getCenterText(item?.value) }}</tspan>
        </text>
    </svg>
</dx-pie-chart>